import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AddReceipt, LoadReceipt, RemoveReceipt } from './receipt.actions';
import { ReceiptModel } from './receipt.model';

export class ReceiptStateModel {
  receipt: ReceiptModel;
}

@State<ReceiptStateModel>({
  name: 'ReceiptStateModel',
  defaults: new ReceiptStateModel()
})
@Injectable()
export class ReceiptState {
  constructor() {}

  @Selector()
  static receipt(state: ReceiptStateModel): ReceiptModel {
    return state.receipt;
  }

  @Action(LoadReceipt)
  onLoadReceipt(
    { getState }: StateContext<ReceiptStateModel>,
  ) {

    return getState().receipt;
  }

  @Action(AddReceipt)
  onAddReceipt(
    { patchState }: StateContext<ReceiptStateModel>,
    { data }: AddReceipt
  ) {

    patchState({ receipt: data });
  }


  @Action(RemoveReceipt)
  onClearCart(
    {  patchState }: StateContext<ReceiptStateModel>,
    { }: RemoveReceipt
  ) {
    
    patchState({ receipt: null });
  }
}
